import UserIcon from 'elements/UserIcon'
import { SellerIntegrationType } from 'opensolar-common'
import { styled } from 'opensolar-ui'
import { RowCentered } from 'projectSections/sections/manage3/styles'

const RowContainer = styled(RowCentered, { name: 'RowContainer' })({
  flex: 1,
  minWidth: 0,
  gap: 5,
})

const RowDisplay = styled('div', { name: 'RowDisplay' })({
  minWidth: 0,
  flex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  '& > div': {
    display: 'inline-block',
    verticalAlign: 'middle',
    gap: 5,
  },
})

const UserIconContainer = styled('div', { name: 'UserIconContainer' })({
  marginRight: 5,
})

interface SupplierDropdownRowProps {
  supplier: SellerIntegrationType
}

const QuoteReviewWidgetSupplierOption: React.FC<SupplierDropdownRowProps> = ({ supplier }) => (
  <RowContainer>
    <RowDisplay>
      {supplier?.name}
      {supplier?.accountManager ? (
        <>
          {' - '}
          <UserIconContainer>
            <UserIcon user={supplier.accountManager} size={20} />
          </UserIconContainer>
          {`${supplier?.accountManager?.display || supplier?.accountManager?.email}`}
        </>
      ) : null}
    </RowDisplay>
  </RowContainer>
)

export default QuoteReviewWidgetSupplierOption
